import { useMutation } from '@tanstack/react-query';
import { resetPassword } from 'api/services/auth';
import { routesSettings } from 'constants/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import ToastHelper from 'utils/toast';
import ResetPasswordView from './ResetPassword.view';

const ResetPasswordContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get code from query parameter
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code') || '';

  const goToLogin = () => {
    navigate(routesSettings.AUTH_LOGIN.path, {
      replace: true,
    });
  };

  const { mutate, isPending } = useMutation({
    mutationFn: (payload: { password: string; confirmPassword: string }) => {
      console.log(payload);
      const { password: newPassword } = payload;
      return resetPassword({ newPassword, code });
    },
    onSuccess: (data) => {
      ToastHelper.success('Password reset successfully');
      // Show success message or redirect to login
      navigate(routesSettings.AUTH_LOGIN.path, {
        replace: true,
      });
    },
    onError: (error) => {
      ToastHelper.error('Password reset invalid or expired');
      navigate(routesSettings.AUTH_LOGIN.path, {
        replace: true,
      });
    },
  });

  return (
    <ResetPasswordView
      onSubmit={mutate}
      isLoading={isPending}
      goToLogin={goToLogin}
      code={code}
    />
  );
};

export default ResetPasswordContainer;
